import React, { useState } from "react";
import { Button, Group, Select, Text } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import AgingReportView from "./accounting/AgingReportView";

const AGING_TYPES = [
  { label: "AR - Clients", value: "AR_CLIENT" },
  { label: "AP - Insurers", value: "AP_INSURER" },
  { label: "Consultant Payable", value: "CONSULTANT_PAYABLE" },
  { label: "Client Deposits", value: "CLIENT_DEPOSIT" },
];

const ReportAging = () => {
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [type, setType] = useState("AR_CLIENT");
  const [asOfDate, setAsOfDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.Accounting.getAging(
        type,
        asOfDate ? asOfDate.toISOString() : undefined
      );
      setRows(data?.rows || data || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs" mb="xs">
        {t("AR/AP aging by subledger type.")}
      </Text>
      <Group align="flex-end">
        <Select
          size="xs"
          label={t("Subledger Type")}
          data={AGING_TYPES}
          value={type}
          onChange={setType}
          style={{ minWidth: 200 }}
        />
        <DatePicker
          size="xs"
          label={t("As of Date")}
          value={asOfDate}
          onChange={setAsOfDate}
          allowFreeInput
        />
        <Button size="xs" onClick={load} loading={loading}>
          {t("Run Report")}
        </Button>
      </Group>
      <div style={{ marginTop: 16 }}>
        <AgingReportView rows={rows} />
      </div>
    </div>
  );
};

export default ReportAging;
